import React from 'react';
import cl from '../Stub.module.css';
import usePageMeta from '../../hooks/usePageMeta';

// Публичная оферта на оказание услуг. Базовый текст, после запуска
// прода — проверить с юристом и при необходимости дополнить.
export default function Oferta() {
    usePageMeta({
        title: 'Публичная оферта · СтартКласс',
        description: 'Договор-оферта на оказание услуг по предоставлению доступа к платформе СтартКласс.',
        canonical: 'https://startklass.ru/oferta',
    });
    return (
        <main className={cl.page} style={{ maxWidth: 820, textAlign: 'left' }}>
            <span className={cl.eyebrow}>Юридическое</span>
            <h1 className={cl.title} style={{ textAlign: 'left' }}>
                Публичная оферта на оказание услуг
            </h1>
            <p className={cl.text} style={{ textAlign: 'left' }}>
                Действует со 2 августа 2026 г. Редакция 1.1.
            </p>

            <h2 style={H2}>1. Стороны</h2>
            <p style={P}>
                <b>Исполнитель:</b> <b>ИП Иванкова Виктория Сергеевна</b>,
                ОГРНИП 322237500039230, ИНН 233507286445,
                адрес: Краснодарский край, г. Кореновск, ул. Мира 93,
                e-mail: <a href="mailto:maksimivankov26@yandex.ru">maksimivankov26@yandex.ru</a>.
            </p>
            <p style={P}>
                <b>Заказчик:</b> индивидуальный предприниматель или юридическое
                лицо, осуществляющее деятельность в сфере дополнительного
                образования детей, оформившее заявку через сайт startklass.ru.
            </p>

            <h2 style={H2}>2. Предмет договора</h2>
            <p style={P}>
                Исполнитель предоставляет Заказчику доступ к образовательной
                платформе «СтартКласс», включающей три модуля:
            </p>
            <ul style={UL}>
                <li><b>«Майнкрафтия»</b> — программирование (Scratch, Python, Flask),
                    Minecraft-серверы, 20+ курсов;</li>
                <li><b>«Роботехника»</b> — электроника, 3D-моделирование,
                    50 проектов на Arduino;</li>
                <li><b>Админ-панель центра</b> — журнал учеников, посещений, оплат.</li>
            </ul>

            <h2 style={H2}>3. Тарифы</h2>
            <ul style={UL}>
                <li><b>Раннее бронирование (март–июнь)</b>: 100 000 ₽ за учебный год.</li>
                <li><b>Стандарт (июль–февраль)</b>: 150 000 ₽ за учебный год.</li>
                <li><b>Помесячно</b>: 25 000 ₽ за календарный месяц.</li>
            </ul>
            <p style={P}>
                В стоимость включено: 200 учеников, 5 преподавателей, доступ ко
                всему контенту платформы, обновления курсов, личная поддержка.
            </p>
            <p style={P}>
                Сверхлимитные пользователи (доплата по факту):
                +1 ученик — 1 000 ₽/мес, +1 преподаватель — 5 000 ₽/мес.
            </p>

            <h2 style={H2}>4. Порядок оплаты</h2>
            <p style={P}>
                Оплата производится одним из способов на выбор Заказчика:
            </p>
            <ul style={UL}>
                <li><b>По счёту</b> — банковским переводом на расчётный счёт
                    Исполнителя. Счёт выставляется в личном кабинете центра.</li>
                <li><b>Картой или через СБП</b> — онлайн в личном кабинете,
                    через платёжный сервис АО «Тинькофф Банк». Реквизиты карты
                    вводятся на стороне банка и Исполнителю не передаются.</li>
            </ul>
            <p style={P}>
                Доступ к платформе активируется в течение 1 рабочего дня после
                поступления оплаты по счёту и автоматически — при оплате картой
                или через СБП.
            </p>
            <p style={P}>
                Закрывающие документы (акт оказанных услуг) предоставляются по
                запросу Заказчика. При оплате картой или через СБП кассовый чек
                направляется на электронную почту, указанную при регистрации,
                в порядке, предусмотренном Федеральным законом № 54-ФЗ.
            </p>

            <h2 style={H2}>5. Срок действия и продление</h2>
            <p style={P}>
                Договор действует с даты активации доступа до окончания
                оплаченного периода. Продление осуществляется выставлением
                нового счёта либо оплатой картой в личном кабинете.
            </p>
            <p style={P}>
                При неоплате доступ к платформе приостанавливается, учётные
                записи учеников и преподавателей отключаются, данные центра
                сохраняются не менее 90 календарных дней. По письменному
                заявлению Заказчика данные удаляются раньше этого срока.
            </p>

            <h2 style={H2}>6. Возврат средств</h2>
            <p style={P}>
                В первые <b>14 календарных дней</b> с даты активации Исполнитель
                возвращает полную сумму без вопросов по письменному заявлению
                Заказчика. Далее — пропорционально неиспользованным дням
                оплаченного периода. Заявление направляется на e-mail Исполнителя.
            </p>

            <h2 style={H2}>7. Права и обязанности сторон</h2>
            <p style={P}><b>Исполнитель обязан:</b></p>
            <ul style={UL}>
                <li>Обеспечивать доступность платформы 24/7 (за исключением
                    плановых работ, о которых уведомляет за 24 часа);</li>
                <li>Сохранять конфиденциальность данных центра и его учеников;</li>
                <li>Обновлять контент и предоставлять техническую поддержку.</li>
            </ul>
            <p style={P}><b>Заказчик обязан:</b></p>
            <ul style={UL}>
                <li>Не передавать учётные данные третьим лицам;</li>
                <li>Своевременно оплачивать подписку и доплаты за сверхлимиты;</li>
                <li>Не использовать платформу для коммерческого распространения
                    контента в обход настоящего договора.</li>
            </ul>

            <h2 style={H2}>8. Персональные данные учеников</h2>
            <p style={P}>
                Для работы платформы Заказчик передаёт Исполнителю
                персональные данные своих учеников (имя, класс, данные о
                занятиях и успеваемости), в том числе данные
                несовершеннолетних.
            </p>
            <p style={P}>
                В отношении этих данных <b>Заказчик является оператором</b>
                персональных данных, а <b>Исполнитель — лицом, обрабатывающим
                персональные данные по поручению оператора</b> (ст. 6 ч. 3
                Федерального закона № 152-ФЗ). Настоящий договор является
                поручением на обработку.
            </p>
            <p style={P}>Исполнитель обязуется:</p>
            <ul style={UL}>
                <li>обрабатывать данные учеников исключительно для
                    предоставления доступа к платформе и ведения учёта
                    занятий — иные цели не допускаются;</li>
                <li>не передавать данные третьим лицам, кроме случаев,
                    предусмотренных законом;</li>
                <li>соблюдать конфиденциальность и требования к защите
                    данных, установленные ст. 19 № 152-ФЗ;</li>
                <li>по требованию Заказчика удалить данные его учеников или
                    передать их Заказчику.</li>
            </ul>
            <p style={P}>
                Заказчик гарантирует, что получил согласия родителей
                (законных представителей) несовершеннолетних учеников на
                передачу их данных Исполнителю, и несёт ответственность за
                наличие таких согласий.
            </p>
            <p style={P}>
                Данные хранятся и обрабатываются на серверах, расположенных
                на территории Российской Федерации.
            </p>

            <h2 style={H2}>9. Ответственность сторон</h2>
            <p style={P}>
                Стороны несут ответственность в соответствии с законодательством РФ.
                Исполнитель не несёт ответственности за качество связи у Заказчика
                и сбои в работе сторонних сервисов (банки, интернет-провайдеры).
            </p>

            <h2 style={H2}>10. Реквизиты Исполнителя</h2>
            <p style={P}>
                <b>ИП Иванкова Виктория Сергеевна</b><br/>
                ОГРНИП: 322237500039230<br/>
                ИНН: 233507286445<br/>
                Адрес: Краснодарский край, г. Кореновск, ул. Мира 93<br/>
                E-mail: <a href="mailto:maksimivankov26@yandex.ru">maksimivankov26@yandex.ru</a><br/>
                Сайт: <a href="https://startklass.ru">startklass.ru</a>
            </p>
        </main>
    );
}


const H2 = { marginTop: 28, marginBottom: 10, color: '#0f172a', fontSize: 18, fontWeight: 700 };
const P  = { color: '#475569', fontSize: 15, lineHeight: 1.7, marginBottom: 10 };
const UL = { color: '#475569', fontSize: 15, lineHeight: 1.7, marginBottom: 10, paddingLeft: 22 };
